import { render, staticRenderFns } from "./StudentQuizSubject.vue?vue&type=template&id=3da390b9"
import script from "./StudentQuizSubject.vue?vue&type=script&lang=js"
export * from "./StudentQuizSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports